<script lang="ts" setup>
import type { Address } from '~/types'

const props = defineProps<{ address?: Address, placeholder?: string, disabled?: boolean }>()
const emit = defineEmits<{
  (e: 'update:address', address: Address): void
  (e: 'showAutocompleteInput'): void
}>()

const placeholders = useStringAddress(props.placeholder)

const street = ref(props.address?.street ?? '')
const postcode = ref(props.address?.postcode ?? '')
const city = ref(props.address?.city ?? '')

const handleInput = () => emit('update:address', {
  street: street.value,
  postcode: postcode.value,
  city: city.value,
  country: undefined,
  longitude: undefined,
  latitude: undefined,
})
</script>

<template>
  <div class="flex flex-col gap-2 border p-3 mt-2 bg-gray-100 rounded">
    <label>
      <span class="text-sm">
        {{ $t('form.address.street.label') }}:
      </span>
      <n-input
        v-model:value="street"
        size="large"
        :placeholder="placeholders?.street"
        :disabled="disabled"
        @update:value="e => handleInput()"
      />
    </label>
    <div class="grid grid-cols-2 md:gap-4">
      <label>
        <span class="text-sm">
          {{ $t('form.address.postcode.label') }}:
        </span>
        <n-input
          v-model:value="postcode"
          size="large"
          :placeholder="placeholders?.postcode"
          :disabled="disabled"
          @update:value="e => handleInput()"
        />
      </label>
      <label>
        <span class="text-sm">
          {{ $t('form.address.city.label') }}:
        </span>
        <n-input
          v-model:value="city"
          size="large"
          :placeholder="placeholders?.city"
          :disabled="disabled"
          @update:value="e => handleInput()"
        />
      </label>
    </div>
    <n-button
      size="small"
      class="mt-1 rounded-md"
      @click="emit('showAutocompleteInput')"
    >
      {{ $t("address.input.switch.button") }}
    </n-button>
  </div>
</template>
